import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from '../../config/posthog';

/**
 * Tracks page views in PostHog on every route change.
 * Place this inside <Router> so useLocation() works.
 */
export default function PostHogPageviewTracker() {
  const location = useLocation();

  useEffect(() => {
    posthog.capture('$pageview', {
      $current_url: window.location.href,
    });
  }, [location.pathname, location.search]);

  return null;
}
